import React, { useCallback, useMemo } from 'react';
import { FilloutStandardEmbed } from '@fillout/react';
import { useLocation } from 'react-router-dom';
import {
  getFilloutAttribution,
  getFilloutDirectUrl,
  getFilloutStorage,
  trackFilloutConversion,
} from '../utils/filloutTracking';

const FORM_ID = 'hbi4VT1VjAus';
const embedStyle = { width: '100%' };
const wrapperStyle = {
  width: '100%',
  minHeight: '500px',
  height: 'auto',
};

export default function FilloutEmbed() {
  const { search } = useLocation();

  const parameters = useMemo(
    () => getFilloutAttribution(search, window.paduaInquiryAttribution),
    [search]
  );
  const directUrl = useMemo(
    () => getFilloutDirectUrl(FORM_ID, parameters),
    [parameters]
  );

  const handleSubmit = useCallback((submissionId) => {
    trackFilloutConversion({
      formId: FORM_ID,
      submissionId,
      hostname: window.location.hostname,
      gtag: window.gtag,
      storage: getFilloutStorage(window),
    });
  }, []);

  return (
    <div style={wrapperStyle}>
      <FilloutStandardEmbed
        filloutId={FORM_ID}
        dynamicResize
        parameters={parameters}
        onSubmit={handleSubmit}
        style={embedStyle}
      />
      <a
        href={directUrl}
        className="mt-4 inline-block text-sm text-brand-olive underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-olive"
      >
        Open the inquiry form directly
      </a>
    </div>
  );
}